import React, { useRef, useEffect, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { a } from "@react-spring/three";
import * as THREE from "three";
import ModelScene from "../accests/3d/skameiki_n.glb";
import gsap from "gsap";

const Skameiki_n = (props) => {
  const { nodes, materials } = useGLTF(ModelScene);
  const [hovered, hover] = useState(false);

  const colorChange = async () => {
    let key = Object.keys(materials);
    if (props.fog && !hovered)
      key.forEach((element) => {
        if (element != "окна" && element != "выступы")
          gsap.to(materials[element].emissive, 0.3, {
            r: 0.5,
            g: 0.5,
            b: 0.5,
          });
      });
    else {
      key.forEach((element) => {
        if (element != "окна" && element != "выступы")
          gsap.to(materials[element].emissive, 0.3, {
            r: 0,
            g: 0,
            b: 0,
          });
      });
    }
  };
  useEffect(() => {
    colorChange();
  }, [props.fog]);
  const modelRef = useRef();
  return (
    <a.group
      {...props}
      ref={modelRef}
      
    >
        <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube007.geometry}
        material={materials.окружение}
        position={[20.956, -0.347, 0]}
        rotation={[-0.182, -1.571, 0]}
        scale={[0.354, 0.378, 0.76]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube010.geometry}
        material={materials.окружение}
        position={[-109.703, -0.39, -28.984]}
        rotation={[-Math.PI, 1.56, -2.96]}
        scale={[0.354, 0.378, 0.76]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube012.geometry}
        material={materials.окружение}
        position={[90.972, -0.347, 35.664]}
        rotation={[-0.182, -1.571, 0]}
        scale={[0.354, 0.378, 0.76]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube013.geometry}
        material={materials.окружение}
        position={[0, -0.364, 0]}
        rotation={[-0.182, -1.571, 0]}
        scale={[0.354, 0.378, 0.76]}
      />
    </a.group>
  );
};

export default Skameiki_n;
